import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";

import HelpIcon from "@mui/icons-material/Help";
import AddToDriveIcon from "@mui/icons-material/AddToDrive";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import { actionAppToggleComponent } from "../App";
import {
  actionSheetExpandToggled,
  actionSheetUploadToggled,
  actionSharedDataFilesUpdated,
  actionSharedDataFilesComponentToggled,
} from "./spreadsheetRedux";
import { listSharedDataFiles } from "./sharedDatasetApi.js";
import Accordian from "../Shared/Accordion";
import SpreadsheetCard from "./SpreadsheetCard";
import ExportDialog from "./ExportDialog";
import { trackEvent } from "../../tracking";
import { MGIS_DOC_LINK } from "../Shared/util";

const btnSecondary_ = (theme) => ({
  color: "black",
  backgroundColor: "#E0E0E0",
});

const box_ = (theme) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  py: 1,
});

export default function Spreadsheet() {
  const component = "spreadsheetVisible";
  const isVisible = useSelector((state) => state.appReducer[component]);
  const idToken = useSelector((state) => state.authReducer.idToken);
  const { isExpanded, files } = useSelector(
    (state) => state.spreadsheetReducer,
  );
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [sharedLoading, setSharedLoading] = useState(false);

  const handleSharedData = async () => {
    setSharedLoading(true);
    const files = await listSharedDataFiles(idToken);
    dispatch(actionSharedDataFilesUpdated(files));
    setSharedLoading(false);
    dispatch(actionSharedDataFilesComponentToggled());
  };

  const visibleHandler = () => {
    dispatch(actionAppToggleComponent({ component }));
  };

  const expandHandler = () => {
    dispatch(actionSheetExpandToggled());
  };

  const handleUpload = (event) => {
    event.stopPropagation();
    dispatch(actionSheetUploadToggled());
  };

  useEffect(() => {
    if (isVisible && isExpanded) {
      trackEvent({
        category: "Custom Data",
        action: "Spreadsheet",
      });
    }
  }, [isVisible, isExpanded]);

  return (
    <Accordian
      title="Spreadsheet"
      visible={isVisible}
      visibleHandler={visibleHandler}
      expand={isExpanded}
      expandHandler={expandHandler}
    >
      <>
        <Box>
          {files.map(({ id }) => {
            return <SpreadsheetCard key={id} sheetId={id} />;
          })}
        </Box>
        <Box sx={box_}>
          <Tooltip title="Connect to Google Drive">
            <Fab
              disabled={sharedLoading}
              aria-label="Add file from Google Drive"
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSharedData}
              style={{ marginRight: 8 }}
            >
              <AddToDriveIcon />
            </Fab>
          </Tooltip>
          <Tooltip title="Upload Spreadsheet">
            <IconButton
              variant="outlined"
              color="primary"
              onClick={handleUpload}
              aria-label="Upload local file"
            >
              <FileUploadIcon />
            </IconButton>
          </Tooltip>
          <Tooltip describeChild title="Download Spreadsheet">
            <span>
              {" "}
              {/* span needed to wrap disabled IconButton for tooltip to work */}
              <IconButton
                sx={btnSecondary_}
                onClick={() => {
                  setDialogOpen(true);
                }}
                disabled={files.length === 0}
                aria-label={`Download layer data${files?.length === 0 ? " (Not Available)" : ""}`}
              >
                <FileDownloadIcon />
              </IconButton>
            </span>
          </Tooltip>
          <ExportDialog setDialogOpen={setDialogOpen} dialogOpen={dialogOpen} />
          <IconButton
            aria-label="More info"
            href={`${MGIS_DOC_LINK}/edit?tab=t.rvf178s3jjeo`}
            target="_blank"
            size="large"
          >
            <HelpIcon />
          </IconButton>
        </Box>
      </>
    </Accordian>
  );
}
